import styled, { css, keyframes } from "styled-components";

const ICON_WIDTH = 48;
const ANIMATION_DURATION = 800;
const ANIMATION_DELAY = 800;
const BUTTON_WIDTH = 80;

const subtleBumpAnimation = keyframes`
    0%, 100% {
        transform: translate3d(0, 0, 0);
    }
    50% {
        transform: translate3d(10px, 0, 0);
    }
`;

const subtleBumpAnimationOnTap = keyframes`
    0%, 100% {
        transform: translate3d(0, 0, 0);
    }
    50% {
        transform: translate3d(25px, 0, 0);
    }
`;

const shimmerAnimation = keyframes`
    0% {
        transform: skewX(-40deg) translate3d(-100px, 0, 0);
    }
    66%, 100% {
        transform: skewX(-40deg) translate3d(400px, 0, 0);
    }
`;

export const Container = styled.div`
    display: flex;
    align-items: center;
    height: 58px;
    width: 100%;
    border-radius: 56px;
    padding: 0 6px;
    transition: height 0.1s linear;
    position: relative;
    overflow: hidden;
    background: ${({ theme }) => theme.colors[theme.colorMode].special_positive};

    &::after {
        content: "";
        position: absolute;
        top: 0;
        width: 30px;
        height: 100%;
        opacity: 0.2;
        background-color: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
        animation: ${shimmerAnimation} 2s ease-in-out;
        will-change: left;
        transform: translate3d(-100px, 0, 0) skewX(-40deg);
        filter: blur(10px);
        animation-iteration-count: 1;
        animation-delay: ${ANIMATION_DELAY}ms;
        animation-timing-function: ease-in-out;
    }
`;

export const Slider = styled.span<{ $isLarge?: boolean }>`
    width: fit-content;
    height: fit-content;
    z-index: 1;

    ${({ $isLarge }) =>
        $isLarge &&
        css`
            width: 45%;
        `};
`;

export const SwipeButton = styled.button<{
    $showInitialAnimation?: boolean;
    $showTapAnimation?: boolean;
}>`
    border: none;
    background: none;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${BUTTON_WIDTH}px;
    height: ${BUTTON_WIDTH}px;
    position: relative;
    will-change: left;
    touch-action: pan-x;
    padding: 0px 6px;
    margin-left: -22px;
    box-sizing: content-box;
    cursor: pointer;

    ${props =>
        props.$showInitialAnimation &&
        css`
            animation: ${subtleBumpAnimation} ${ANIMATION_DURATION}ms cubic-bezier(0, 0, 0.37, 0.98)
                ${ANIMATION_DELAY}ms;
        `}

    ${props =>
        props.$showTapAnimation &&
        css`
            animation: ${subtleBumpAnimationOnTap} ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1) !important;
        `}
`;

export const IconContainer = styled.div`
    width: ${ICON_WIDTH}px;
    height: ${ICON_WIDTH}px;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.12);
    border-radius: ${ICON_WIDTH}px;
`;

export const Content = styled.div`
    position: absolute;
    left: ${ICON_WIDTH / 2}px;
    right: 0px;
    text-align: center;
`;

export const SubText = styled.span`
    margin-left: 4px;
`;

export const SubTextContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 2px;
`;

export const DiscountSubText = styled.span`
    text-decoration: line-through;
    margin-right: 4px;
`;
